var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17578 3.75L20.1758 20.25",
    stroke: "#676A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1973 14.7751C14.5091 15.4055 13.6087 15.7536 12.6754 15.7501C11.9185 15.75 11.1794 15.5209 10.5551 15.0929C9.9309 14.6649 9.4508 14.058 9.17794 13.352C8.90508 12.646 8.85224 11.874 9.02636 11.1374C9.20048 10.4008 9.59342 9.73418 10.1535 9.2251",
    stroke: "#676A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61328 6.43115C3.78828 8.3624 2.17578 11.9999 2.17578 11.9999C2.17578 11.9999 5.17578 18.7499 12.6758 18.7499C14.4332 18.7642 16.1687 18.3593 17.7383 17.5687",
    stroke: "#676A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2313 15.8531C22.275 14.025 23.175 12 23.175 12C23.175 12 20.175 5.25002 12.675 5.25002C12.0248 5.24874 11.3756 5.30205 10.7344 5.4094",
    stroke: "#676A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3789 8.31567C14.1764 8.46678 14.9031 8.87317 15.4493 9.47353C15.9956 10.0739 16.3317 10.8356 16.407 11.6438",
    stroke: "#676A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.944c939a1903c12d501515394591e96d.svg";
export { ForwardRef as ReactComponent };